<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      @click="closeModal"
    >
      <div
        class="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 overflow-auto transition-all duration-300"
        @click.stop
      >
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <span v-if="header" class="text-lg font-semibold text-content">{{ header }}</span>
          <button
            class="text-2xl font-bold text-slate-400 hover:text-black transition"
            @click="closeModal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div class="p-5 scrollable-height">
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
     header: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  methods: {
    closeModal() {
      this.$emit('update:modelValue', false)
    }
  }
}
</script>
<style scoped>
.scrollable-height{
  @apply max-h-[calc(100vh-10rem)] overflow-y-auto;
}
</style>

